module.exports = __webpack_public_path__ + "img/3good.f541a448.svg";